
import { RouteShareService } from "src/app/shared/services/route-share.service";
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BlocklyToolboxCategory } from "../blocky-types.types";

export function BlocklyCategory_SKILLS(name: string = "unnamed", BH: BlocklyHelperService, rss: RouteShareService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.SKILLS, name: name, contents: [] };
  cat.contents = [
    BH.StackedBlockContents("SKILL", ["Alle Skills|___ALL___", ...rss._allSkills()]),
    BH.castTypeBlock("SKILL"),
    BH.label("Aktionen"),
    /* { kind: 'block', type: 'BLOCK_STACK_SKILL' } as any, */

    BH.withNested(
      BH.action("SKILL_DISABLE", "Skill deaktivieren {{ skill[@check=SKILL] }}", "await RAGAI.SKILL.disableSkills([{{skill}}]);"),
      [{ forValue: "skill", isShadow: true, targetBlockType: 'BLOCK_STACK_SKILL' }]
    ),
    BH.withNested(
      BH.action("SKILL_ENABLE", "Skill aktivieren {{ skill[@check=SKILL] }}", "await RAGAI.SKILL.enableSkills([{{skill}}]);"),
      [{ forValue: "skill", isShadow: true, targetBlockType: 'BLOCK_STACK_SKILL' }]
    ),
    { kind: 'block', type: 'SKILL_FOR_NEXT_RUN_NEW' } as any,
    BH.label("Eigenschaften & Werte"),
    //BH._custom("SKILL_LIST_ALL", "@output:String\nListe aller Skills", "await RAGAI.SKILL.getSkills()", { colour: BLOCKLY_COLORS.PROPERTIES }),
    //BH._custom("SKILL_LIST_ENABLED", "@output:String\nListe aktivierter Skills", "(await RAGAI.SKILL.getSkills()).filter(s => s.enabled)", { colour: BLOCKLY_COLORS.PROPERTIES }),
    //BH._custom("SKILL_LIST_DISABLED", "@output:String\nListe deaktivierter Skills", "(await RAGAI.SKILL.getSkills()).filter(s => !s.enabled)", { colour: BLOCKLY_COLORS.PROPERTIES }),
    BH._custom("SKILL_COUNT_ENABLED", "@output:Number\nAnzahl aktivierter Skills", "(await RAGAI.SKILL.getSkills()).filter(s => s.enabled).length", { colour: BLOCKLY_COLORS.PROPERTIES }),
    BH._custom("SKILL_COUNT_DISABLED", "@output:Number\nAnzahl deaktivierter Skills", "(await RAGAI.SKILL.getSkills()).filter(s => !s.enabled).length", { colour: BLOCKLY_COLORS.PROPERTIES }),
    BH._custom("SKILL_COUNT_TOTAL", "@output:Number\nAnzahl Skills gesamt", "(await RAGAI.SKILL.getSkills()).length", { colour: BLOCKLY_COLORS.PROPERTIES })
  ];

  // Deprecated – nur registrieren, nicht in Toolbox anzeigen
  BH.actionDropdown("SKILL_ACTIONS", "SKILL", [
    ["disableAllSkills()", "await RAGAI.SKILL.disableAllSkills();"],
    ["unforceAllSkills()", "await RAGAI.SKILL.unforceAllSkills();"]
  ]);
  BH.action("SKILL_ENABLECHILD", "Skill und Kinder aktivieren: Tiefe {{ depth:number=1 }} {{ skill[@check=SKILL] }}", "await RAGAI.SKILL.enableSkillAndChildren({{skill}}, {{depth}});");
  BH.action("SKILL_DISABLECHILD", "Skill und Kinder deaktivieren: Tiefe {{ depth:number=1 }} {{ skill[@check=SKILL] }}", "await RAGAI.SKILL.disableSkillAndChildren({{skill}}, {{depth}});");

  return cat;

}
